/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService
 */
import * as References from './CatalogResourceChirpFrontendService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService#getCatalogResources
 */
export const GET_CATALOG_RESOURCES_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_v1_CatalogResourceChirpFrontendService_getCatalogResources';
export const GET_CATALOG_RESOURCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CATALOG_RESOURCES_QUERY_FIELD_NAME,
  args: ['requestedResources'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCatalogResourcesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});